import React, { useState, useEffect } from 'react';

export default function WesternRebelsSplash() {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    setIsLoaded(true);
  }, []);

  return (
    <div className="min-h-screen bg-black text-white relative overflow-hidden">
      {/* Video Background */}
      <div className="absolute inset-0 z-0">
        <video 
          autoPlay 
          muted 
          loop 
          playsInline
          className="w-full h-full object-cover opacity-50"
        >
          <source src="/video/WesternRebelsBackground.mp4" type="video/mp4" />
        </video>
        <div className="absolute inset-0 bg-black bg-opacity-60"></div>
      </div>

      {/* Main Content */}
      <div className={`relative z-10 flex flex-col items-center justify-center min-h-screen px-8 transition-all duration-1000 ${isLoaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
        
        {/* Logo */}
        <div className="mb-12">
          <img 
            src="/wr-logo-transparent.png" 
            alt="Western Rebels Logo"
            className="w-40 h-40 mx-auto drop-shadow-2xl hover:scale-105 transition-transform duration-300"
          />
        </div>

        {/* Team Name */}
        <h1 className="text-5xl md:text-7xl font-bold text-center mb-4 tracking-wider">
          WESTERN REBELS
        </h1>

        {/* Tagline */}
        <p className="text-xl md:text-2xl text-gray-300 text-center mb-16 font-light tracking-wide">
          AIRSOFT TEAM
        </p>

        {/* Discord Button */}
        <a 
          href="https://discord.gg/SUmAmKJUmB"
          target="_blank"
          rel="noopener noreferrer"
          className="group relative inline-flex items-center justify-center px-8 py-4 text-lg font-semibold text-white bg-transparent border-2 border-white hover:bg-white hover:text-black transition-all duration-300 uppercase tracking-wider"
        >
          <svg className="w-6 h-6 mr-3" viewBox="0 0 24 24" fill="currentColor">
            <path d="M20.317 4.3698a19.7913 19.7913 0 00-4.8851-1.5152.0741.0741 0 00-.0785.0371c-.211.3753-.4447.8648-.6083 1.2495-1.8447-.2762-3.68-.2762-5.4868 0-.1636-.3933-.4058-.8742-.6177-1.2495a.077.077 0 00-.0785-.037 19.7363 19.7363 0 00-4.8852 1.515.0699.0699 0 00-.0321.0277C.5334 9.0458-.319 13.5799.0992 18.0578a.0824.0824 0 00.0312.0561c2.0528 1.5076 4.0413 2.4228 5.9929 3.0294a.0777.0777 0 00.0842-.0276c.4616-.6304.8731-1.2952 1.226-1.9942a.076.076 0 00-.0416-.1057c-.6528-.2476-1.2743-.5495-1.8722-.8923a.077.077 0 01-.0076-.1277c.1258-.0943.2517-.1923.3718-.2914a.0743.0743 0 01.0776-.0105c3.9278 1.7933 8.18 1.7933 12.0614 0a.0739.0739 0 01.0785.0095c.1202.099.246.1981.3728.2924a.077.077 0 01-.0066.1276 12.2986 12.2986 0 01-1.873.8914.0766.0766 0 00-.0407.1067c.3604.698.7719 1.3628 1.225 1.9932a.076.076 0 00.0842.0286c1.961-.6067 3.9495-1.5219 6.0023-3.0294a.077.077 0 00.0313-.0552c.5004-5.177-.8382-9.6739-3.5485-13.6604a.061.061 0 00-.0312-.0286zM8.02 15.3312c-1.1825 0-2.1569-1.0857-2.1569-2.419 0-1.3332.9555-2.4189 2.157-2.4189 1.2108 0 2.1757 1.0952 2.1568 2.419-.0190 1.3332-.9555 2.4189-2.1569 2.4189zm7.9748 0c-1.1825 0-2.1569-1.0857-2.1569-2.419 0-1.3332.9554-2.4189 2.1569-2.4189 1.2108 0 2.1757 1.0952 2.1568 2.419 0 1.3332-.9555 2.4189-2.1568 2.4189Z"/>
          </svg>
          Join Discord
        </a>

        {/* Sponsors */}
        <div className="mt-8 text-center">
          <p className="text-lg text-gray-300">Proud users of</p>
          <p className="text-lg text-gray-300">
            <a 
              href="https://bodyarmorvent.com/?ref=westernrebels.com"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-white transition-colors duration-300"
            ><span className="font-semibold">Body Armor Vent</span></a>,{' '}
            <a 
              href="https://agilitegear.com/?ref=westernrebels.com"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-white transition-colors duration-300"
            ><span className="font-semibold">Agilite</span></a>, and{' '}
            <a 
              href="https://bloctactical.com/?ref=westernrebels.com"
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-white transition-colors duration-300"
            ><span className="font-semibold">Bloc Tactical</span></a>
          </p>
        </div>

        {/* Bottom text */}
        <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 text-center">
          <p className="text-sm text-gray-400 uppercase tracking-widest">
            Tactical • Professional • Chill
          </p>
          <p className="text-sm text-gray-400 uppercase tracking-widest">
            "Therefore be as shrewd as snakes and as innocent as doves." - Matthew 10:16
          </p>
        </div>
      </div>
    </div>
  );
}